import { useEffect, useState } from "react";
import {Select, DatePicker, Button, Input, Modal} from "antd"
import moment from 'moment';
import {comma} from "../../lib/util/numberUtil";
import {getRouletteInfo, playRoulette} from "../../api/api";
import {addWaitingOrder} from "../../actions/posAction";
import image from '../../res/image';
import {modalStyle} from "../../lib/util/codeUtil";

const EventDetail = ({ joinAbleCount, eventIdx, closeEventDetail }) => {
    const [visible, setVisible] = useState(true);
    const [ticketCount, setTicketCount] = useState(0);
    const [eventInfo, setEventInfo] = useState({
        eventEndDate: null,
        eventStartDate: null,
        resultEndDate: null,
        resultStartDate: null,
    });
    const [onMountFlag, setOnMountFlag] = useState(false);

    const close = () => {
        setVisible(false);
        closeEventDetail();
    }


    var rolLength = 6; // 해당 룰렛 콘텐츠 갯수
    var setNum; // 랜덤숫자 담을 변수
    var hiddenInput = document.createElement("input");
    hiddenInput.className = "hidden-input";

    //랜덤숫자부여
    const rRandom = () => {
        var min = Math.ceil(0);
        var max = Math.floor(rolLength - 1);
        return Math.floor(Math.random() * (max - min)) + min;
    };

    const rRotate = (rank) => {
        var panel = document.querySelector(".roulette-main");
        var btn = document.querySelector(".roulette-btn");
        var deg = [];

        // 룰렛 각도 설정(rolLength = 6)
        for (var i = 1, len = rolLength; i <= len; i++) {
            deg.push((360 / len) * i);
        }

        // 랜덤 생성된 숫자를 히든 인풋에 넣기
        var num = 0;
        document.body.append(hiddenInput);
        const rankToSetNum = [4, 5, 0, 1, 2, 3];
        setNum = hiddenInput.value = rankToSetNum[rank];

        // 애니설정
        var ani = setInterval(() => {
            num++;
            panel.style.transform = "rotate(" + 360 * num + "deg)";
            btn.disabled = true; //button,input
            btn.style.pointerEvents = "none"; //a 태그

            // 총 50에 다달했을때, 즉 마지막 바퀴를 돌고나서
            if (num === 50) {
                clearInterval(ani);
                // setNum:6 / 1등 , 0~4 / 2~5등 , 5 / 꽝
                panel.style.transform = `rotate(${deg[setNum]}deg)`;
            }
        }, 50);
    };

    // 정해진 alert띄우기, custom modal등
    const rLayerPopup = (num, rank, prize) => {
        if (rank === 0) {
            alert("앗! 꽝 아쉽군요..");
        } else {
            alert(`축하드립니다. ${rank}등 ${comma(prize)}원 지원에 담청 되었습니다. 당첨자 모두 선발 이후 당점자 발표가 진행됩니다.`);
        }
    };

    const rReset = (ele, rank, prize) => {
        setTimeout(() => {
            ele.disabled = false;
            ele.style.pointerEvents = "auto";
            rLayerPopup(setNum, rank, prize);
            hiddenInput.remove();
        }, 5500);
        setOnMountFlag(!onMountFlag);
    };

    const start = async (e) => {
        if (eventInfo.eventStartDate === null || eventInfo.eventEndDate === null) {
            alert("이벤트 정보를 가져오는데 실패했습니다.");
            return;
        }
        var startDate = moment(eventInfo.eventStartDate);
        var endDate = moment(eventInfo.eventEndDate);
        var now = new moment();

        // 테스트 시 기간 제한 코드 주석
        if (now.isBefore(startDate) || now.isAfter(endDate)) {
            alert(`이벤트 기간은 ${startDate.format("YYYY-MM-DD HH:mm")} ~ ${endDate.format("YYYY-MM-DD HH:mm")} 입니다.`);
            return;
        }
        if (ticketCount <= 0) {
            alert("보유한 티켓이 없습니다.");
            return;
        }

        const res = await playRoulette(eventIdx);
        if (res === null
            || res.result !== 'SUCCESS'
            || res?.data === null
            || res?.data === undefined
            || res?.data?.rank === null
            || res?.data?.rank === undefined
            || res?.data?.prize === null
            || res?.data?.prize === undefined) {
            Modal.info({
                title: "조회실패",
                content: '룰렛결과 조회에 실패했습니다. 다시 시도해주세요.',
                ...modalStyle,
            });
            return;
        }

        let target = e.target;
        if (target.tagName === "BUTTON") {
            rRotate(res.data.rank);
            rReset(target, res.data.rank, res.data.prize);
        }
    }

    useEffect(async () => {
        if (eventIdx === null || eventIdx === undefined || isNaN(eventIdx)) return;
        const res = await getRouletteInfo(eventIdx);
        if (res.result === 'SUCCESS') {
            setTicketCount(res.data?.ticket ? res.data?.ticket : 0);
            setEventInfo(res.data?.eventInfo);
        }
    }, [onMountFlag]);


    return (
        <div className="roullete mobileoff">
            {visible ?
                <div className="roullete-detail-content" >
                    <div className="roullete-detail-close" >

                        <img src={image.closeIcon} alt=""
                            onClick={close} />

                    </div>

                    <div className="roullete-detail-img">
                        <div className="roullete-fr">{`가맹점 참여수 : (현재) ${comma(joinAbleCount)}`}</div>
                        <div className="roullete-main-bg"></div>
                        <div className="roullete-event-bg">
                            <div className="rouletter">
                                <div className="rouletter-bg">
                                    <div className="roulette-main"></div>
                                </div>
                                <div className="btn-box">
                                    <button onClick={(e) => { start(e) }} className="roulette-btn">START</button>
                                </div>
                                <div className="rouletter-bg2">
                                    <div className="roulette-ticket-txt">{`${ticketCount}회`}</div>
                                    <div className="roulette-ticket"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                :
                <></>
            }
        </div>
    )

}

export default EventDetail;
